const PRIMARY = {
    main: '#A06EE1', 
    light: '#BC7AF9' 
};
const SECONDARY = {
    main:"#FACE33"
};
const ERROR = {
    main: "#d32f2f"
};
const WARNING = {
    main: "#ff9800"
};
const INFO = {
    main: "#2e7d32"
};
const SUCCESS = {
    main: "#2e7d32"
};
const COMMON = {
    black: "#000",
    white: "#fff",
};
const GREY = {
    50: "#fafafa",  //grey shades
  100: "#f5f5f5",
  200:'#eeeeee',
  300:'#e0e0e0',
  800:"#657786",//icon
};
const BACKGROUND = {
    paper:'#fff',
    default : '#eeeeef80'
}

const palette = {
    primary : PRIMARY,
    secondary: SECONDARY,
    warning: WARNING,
    info: INFO,
    error: ERROR,
    success : SUCCESS,
    grey : GREY,
    background : BACKGROUND,
    common : COMMON
}
export default palette


